//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AutomationSingle from "./automation-single";
import ApplicationAutomationSingle from "./application-level/application-automation-single";
import { filter, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationList",
  components: {
    AutomationSingle,
    ApplicationAutomationSingle
  },
  props: {
    shareType: {
      type: String,
      default: ""
    },
    automations: {
      type: Array,
      required: true
    },
    boardFilter: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: String,
      required: true
    }
  },
  computed: {
    automationsByShareType() {
      const sharedCheck = this.shareType === "shared";
      const applicationAutomations = this.automations.every(automation => automation.shared == undefined);
      return applicationAutomations ? this.automations : filter(this.automations, automation => automation.shared === sharedCheck);
    },
    automationsFilteredByBoard() {
      if (this.boardFilter.value === "all-boards") return this.automationsByShareType;
      return filter(this.automationsByShareType, automation => automation["trigger-arguments"].board.value === this.boardFilter.value);
    },
    computedAutomations() {
      return isEmpty(this.boardFilter) ? this.automationsByShareType : this.automationsFilteredByBoard;
    },
    automationSingleType() {
      const typeByLevelParser = {
        board: AutomationSingle,
        application: ApplicationAutomationSingle
      };
      return typeByLevelParser[this.level];
    },
    transitionByLevel() {
      return this.level === "application" ? "" : "list-complete";
    }
  }
});